<div class="chart-title-bar" *ngIf="titolo">
  <!-- LEFT: entity | score | events -->
  <div class="chart-title-left">
    <div class="entity-block">
      <div class="name-section">
        <span class="type-label">{{
          loading ? '' : (titolo.entity.type | nicetxt: false)
        }}</span>
        <div
          class="name-row"
          [class.has-dropdown]="routing.isFolio() && entities.length > 0"
        >
          <span
            class="name"
            *ngIf="!loading"
            matTooltipShowDelay="500"
            (click)="openEntityMenu()"
            >{{ titolo.entity.name | nicetxt: false }}</span
          >
          <span class="skeleton skeleton-name" *ngIf="loading"></span>

          <mat-icon
            *ngIf="routing.isFolio() && entities.length > 0"
            #entityMenuTrigger="matMenuTrigger"
            [matMenuTriggerFor]="entityMenu"
            class="query-switch-btn"
            >arrow_drop_down</mat-icon
          >
          <mat-menu #entityMenu="matMenu">
            <button
              mat-menu-item
              [style.background]="!params.type ? 'rgb(50 50 50 / 85%)' : null"
              [style.font-weight]="!params.type ? '600' : null"
              [style.height]="'auto'"
              [style.max-width]="'350px'"
              (click)="select('overall')"
            >
              Overall
            </button>
            <button
              *ngFor="let item of entities"
              mat-menu-item
              [style.background]="
                item.alpha_id === params.id ? 'rgb(50 50 50 / 85%)' : null
              "
              [style.font-weight]="item.alpha_id === params.id ? '600' : null"
              [style.height]="'auto'"
              [style.max-width]="'350px'"
              (click)="select(item)"
            >
              {{ item.name }}
            </button>
          </mat-menu>
        </div>
        <div
          class="benchmark-row"
          *ngIf="
            loading || isLoadingBenchmark || industryBenchmarkScore !== null
          "
        >
          <span
            class="skeleton skeleton-industry"
            *ngIf="loading || isLoadingBenchmark"
          ></span>
          <span
            *ngIf="
              !loading && !isLoadingBenchmark && industryBenchmarkScore !== null
            "
            class="industry-badge"
            [class.laggard]="industryBenchmarkScore === 0"
            [class.below]="industryBenchmarkScore === 1"
            [class.above]="industryBenchmarkScore === 2"
            [class.leader]="industryBenchmarkScore === 3"
          >
            <mat-icon
              *ngIf="industryBenchmarkScore === 0"
              svgIcon="timer-sand-full"
            ></mat-icon>
            <mat-icon
              *ngIf="industryBenchmarkScore === 1"
              svgIcon="trending-down"
            ></mat-icon>
            <mat-icon
              *ngIf="industryBenchmarkScore === 2"
              svgIcon="trending-up"
            ></mat-icon>
            <mat-icon
              *ngIf="industryBenchmarkScore === 3"
              svgIcon="medal"
            ></mat-icon>
            <span class="badge-status">{{ industryBenchmarkStatus }}</span>
            <span class="badge-industry" *ngIf="industryBenchmarkIndustry">
              • {{ industryBenchmarkIndustry }}
            </span>
          </span>
        </div>
      </div>
    </div>

    <div class="metrics-group" *ngIf="!loading">
      <div class="divider"></div>

      <!-- Sentiment only (no score available) — matches query-title style -->
      <div class="sentiment-section" *ngIf="isSentiment">
        <span class="label">Sentiment</span>
        <div class="score-row">
          <span
            class="score"
            [style.color]="titolo.sentiment?.sentiment | color"
            >{{ titolo.sentiment?.sentiment | percent }}</span
          >
          <span
            class="delta-pill"
            [class.negative]="sentimentDelta < 0"
            [class.positive]="sentimentDelta > 0"
          >
            {{ sentimentDelta | round | trend
            }}{{ sentimentDelta | round | negative }}
          </span>
        </div>
      </div>

      <!-- Custom / BB score -->
      <div class="score-section" *ngIf="!isSentiment">
        <span class="label">{{ scoreName }}</span>

        <div class="score-row">
          <!-- Custom score (non-bb) -->
          <span
            class="score"
            *ngIf="!isBb"
            [style.color]="
              auth.getScoreType() === 'pos'
                ? (titolo.score | colorScore2)
                : (titolo.score | colorScore)
            "
            >{{ titolo.score }}</span
          >
          <!-- BB score -->
          <ng-container *ngIf="isBb">
            <span class="score bb-icon">
              <img
                *ngIf="titolo.trend_type === 'bear'"
                src="assets/icon/bear.svg"
              />
              <img
                *ngIf="titolo.trend_type === 'bull'"
                src="assets/icon/bull.svg"
              />
            </span>
            <span
              class="score"
              [style.color]="
                titolo.trend_type === 'bear' ? '#FF2222' : '#50DF6A'
              "
              >{{ titolo.trend_value }}</span
            >
          </ng-container>
          <span
            class="delta-pill"
            *ngIf="scoreDelta !== null && scoreDelta !== 0"
            [class.negative]="scoreDeltaIsNegative"
            [class.positive]="scoreDeltaIsPositive"
          >
            {{ scoreDelta | trend }}{{ displayScoreDelta }}
          </span>
        </div>
      </div>

      <div class="divider"></div>

      <div
        class="score-section events-section"
        *ngIf="
          isLoadingEvents || scoreEventsCount !== null || scoreEventsTimeframe
        "
      >
        <span class="label"
          >Events
          <span class="label-suffix" *ngIf="scoreEventsTimeframe"
            >(last {{ scoreEventsTimeframe }}d)</span
          ></span
        >
        <ng-container *ngIf="isLoadingEvents">
          <span class="skeleton skeleton-count"></span>
          <span class="skeleton skeleton-timeframe"></span>
        </ng-container>
        <ng-container *ngIf="!isLoadingEvents">
          <div class="score-row">
            <span class="events-count" *ngIf="scoreEventsCount !== null">{{
              scoreEventsCount | thousandSuff
            }}</span>
            <span
              class="delta-pill neutral"
              *ngIf="scoreEventsDelta !== null && scoreEventsDelta !== 0"
            >
              {{ scoreEventsDelta | trend
              }}{{ displayEventsDelta | thousandSuff }}
            </span>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Loading skeletons -->
    <div class="metrics-group metrics-group--loading" *ngIf="loading">
      <div class="divider"></div>
      <div class="score-section">
        <span class="skeleton skeleton-timeframe"></span>
        <span class="skeleton skeleton-score"></span>
      </div>
      <div class="divider"></div>
      <div class="score-section events-section">
        <span class="skeleton skeleton-timeframe"></span>
        <span class="skeleton skeleton-count"></span>
      </div>
    </div>
  </div>

  <div class="title-spacer"></div>

  <!-- RIGHT: save → reports -->
  <div class="chart-title-right">
    <div class="chart-title-right-buttons">
      <ng-container
        *ngIf="routing.isMarket() && params.type && !isEntityInAnyPortfolio"
      >
        <button mat-stroked-button [matMenuTriggerFor]="saveMenu">
          <mat-icon>save</mat-icon>
          <span>Save</span>
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #saveMenu="matMenu">
          <button mat-menu-item (click)="onSave('add')">
            Add to existing portfolio
          </button>
          <button mat-menu-item (click)="onSave('create')">
            Add to new portfolio
          </button>
        </mat-menu>
      </ng-container>

      <app-report-box
        *ngIf="(reportStateService.isReportButtonVisible$ | async) && titolo"
        [entity]="titolo.entity"
        [folio]="folio"
        [customScore]="featureFlagsService.scorelabSettings.defaultScore"
        buttonLabel="Report"
      ></app-report-box>
    </div>
  </div>
</div>
